export default __webpack_public_path__ + "static/media/header_books_xs.bdcb26d7.webp";